import { render } from "./footer-two.vue?vue&type=template&id=0ca972fb"
import script from "./footer-two.vue?vue&type=script&lang=js"
export * from "./footer-two.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__